module.exports = __webpack_public_path__ + "img/5starssm.9650076e.png";